export default "__VITE_ASSET__$qn6LnhH__"